import { render, staticRenderFns } from "./PendingTestimonialsListView.vue?vue&type=template&id=2baae052&"
import script from "./PendingTestimonialsListView.vue?vue&type=script&lang=js&"
export * from "./PendingTestimonialsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports